export enum NotificationType {
  Banner = 'banner',
}

export enum NotificationPriority {
  Info = 'info',
  Warning = 'warning',
  Critical = 'critical',
}

export enum ProviderTargetType {
  Solo = 'solo',
  GroupPractice = 'group_practice',
}
